module.exports = __webpack_public_path__ + "assets/img/z1.23085aaf.png";